module.exports = __webpack_public_path__ + "img/banner_detail.d08628ee.jpg";